export default __webpack_public_path__ + "static/media/datePicker.27b12e90.svg";